<template>
  <div class="col-block e-form-subtitle">
    <div class="title">
      <p>{{$translate(text)}}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "e-form-subtitle",
    props: {
      text: {
        type: String,
        default: ''
      }
    }
  }
</script>
